export default __webpack_public_path__ + "static/media/profile-view-active.854207fa.svg";